import { render } from "./AuthUser.vue?vue&type=template&id=9b1f3406"
import script from "./AuthUser.vue?vue&type=script&lang=js"
export * from "./AuthUser.vue?vue&type=script&lang=js"
script.render = render

export default script